module.exports = __webpack_public_path__ + "soundfont/NewDrumSamples/MP3/Ride-1a3c684aae577854478e5b13b35f50c7.mp3";


//////////////////
// WEBPACK FOOTER
// ./soundfont/NewDrumSamples/MP3/Ride.mp3
// module id = 62
// module chunks = 0